export default __webpack_public_path__ + "static/media/gwop.8f1f0801.pptx";